import React from 'react';
import {Outlet} from 'react-router-dom';
import RsvdFtrUi from 'Views/Glb/RsvdFtrUi';


const FtrOnlyLayout = () => {
    return (
        <div className='rootContainer ftrOnlyLayout'>
            <Outlet />
            <RsvdFtrUi gameSvcCd={"bbo"} gameMainPageData={null}/>
        </div>
    );
  }
  export default FtrOnlyLayout;